import { UserRolePermission } from '@schooly/api';

export const canViewMarkbook = (permissions: UserRolePermission[]) => {
  return (
    permissions.includes('assessment_viewer') ||
    permissions.includes('assessment_creator') ||
    permissions.includes('assessment_manager')
  );
};
